import { useState } from "react";
import styled from "@emotion/styled";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

import { BasicFlex } from "../../utils/Common";

import { headers, filters, tabs } from "./config";

const Content = styled(BasicFlex)`
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin: 0 1rem;
  width: auto;
`

const Message = styled.div`
`

const ServiceTicketList = () => {

  let del_warning_msg = <Content>
    <WarningRoundedIcon color="warning" /><Message>This action will permanently delete this Service Ticket, associated Appointments, and attached Invoices.</Message></Content>

  return (
    <Table tableId="service_tickets" title="Service Ticket" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-scheduled_date" idKey="service_ticket_id" tabField="status" tabs={tabs} fieldsToSearch={["Customer", "Ticket ID"]} del_warning_msg={del_warning_msg} />
  );
};

export default ServiceTicketList;